var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameCoinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5C4.47716 0.5 0 4.97715 0 10.5C0 16.0228 4.47716 20.5 10 20.5Z",
    fill: "url(#paint0_linear_1556_9961)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.0604C15.2801 20.0604 19.5605 15.78 19.5605 10.4999C19.5605 5.21981 15.2801 0.939453 10 0.939453C4.71993 0.939453 0.439575 5.21981 0.439575 10.4999C0.439575 15.78 4.71993 20.0604 10 20.0604Z",
    fill: "url(#paint1_linear_1556_9961)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.2657C14.2889 18.2657 17.7657 14.7889 17.7657 10.5C17.7657 6.21117 14.2889 2.73438 10 2.73438C5.71116 2.73438 2.23438 6.21117 2.23438 10.5C2.23438 14.7889 5.71116 18.2657 10 18.2657Z",
    fill: "url(#paint2_linear_1556_9961)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.569C13.904 17.569 17.0688 14.4042 17.0688 10.5002C17.0688 6.5962 13.904 3.4314 10 3.4314C6.09602 3.4314 2.93121 6.5962 2.93121 10.5002C2.93121 14.4042 6.09602 17.569 10 17.569Z",
    fill: "url(#paint3_linear_1556_9961)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04956 12.0222C3.04956 12.0222 4.23099 17.5891 9.95953 17.5891C15.6883 17.5891 16.9504 12.0222 16.9504 12.0222C16.9504 12.0222 15.4455 17.3868 9.95953 17.2654C4.47354 17.1443 3.04956 12.0222 3.04956 12.0222Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.6613 11.4493C16.727 11.0721 16.7616 10.684 16.7616 10.288C16.7616 6.57339 13.7502 3.56201 10.0356 3.56201C6.32101 3.56201 3.30963 6.57339 3.30963 10.288C3.30963 10.7336 3.35341 11.1688 3.43613 11.5901C10.3344 12.4422 14.7726 11.8369 16.6613 11.4493Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.03304 11.2969C2.00453 11.0159 1.94522 10.5962 1.95057 10.3078C2.03303 5.96714 5.4109 2.33654 10.0371 2.36836C14.0386 2.39584 17.7656 5.30796 18.0952 10.1707C18.1166 10.4857 18.056 10.9902 18.0219 11.2971C18.5442 11.1867 19.1179 10.9627 19.2428 10.8212C19.2502 10.6692 19.2543 10.5165 19.2543 10.3626C19.2543 5.25171 15.1027 1.29712 9.9916 1.29712C4.88051 1.29712 0.745972 5.25171 0.745972 10.3626C0.745972 10.5193 0.750049 10.6751 0.757684 10.8298C1.16923 11.1973 1.67316 11.1839 2.03304 11.2969Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7142 18.2657C10.7142 18.2657 15.6043 18.2779 17.3091 13.1284C15.1923 18.055 10.7142 18.2657 10.7142 18.2657Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2395 6.66737C1.2395 6.66737 3.39673 1.54432 7.90819 1.16968C3.76373 1.84642 1.2395 6.66737 1.2395 6.66737Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1556_9961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41295 14.4344C6.97151 14.4344 6.61365 14.0765 6.61365 13.6351V6.75621C6.61365 6.31477 6.97151 5.95691 7.41295 5.95691C7.8544 5.95691 8.21226 6.31477 8.21226 6.75621V7.88251C8.21226 8.75202 8.91713 9.45689 9.78664 9.45689C10.6562 9.45689 11.361 8.75202 11.361 7.88251V6.75621C11.361 6.31477 11.7189 5.95691 12.1603 5.95691C12.6018 5.95691 12.9596 6.31477 12.9596 6.75621V13.6351C12.9596 14.0765 12.6018 14.4344 12.1603 14.4344C11.7189 14.4344 11.361 14.0765 11.361 13.6351V12.4846C11.361 11.6151 10.6562 10.9102 9.78664 10.9102C8.91713 10.9102 8.21226 11.6151 8.21226 12.4846V13.6351C8.21226 14.0765 7.8544 14.4344 7.41295 14.4344Z",
    fill: "#6C5302",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1556_9961",
    x: 6.61365,
    y: 3.23789,
    width: 6.34601,
    height: 11.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6.79754
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35951
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1556_9961"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1556_9961",
    x1: 10,
    y1: 0.500153,
    x2: 10,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D47800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1556_9961",
    x1: 10,
    y1: 0.939606,
    x2: 10,
    y2: 20.0604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FF94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3246,
    stopColor: "#E9C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6911,
    stopColor: "#FFD215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1556_9961",
    x1: 10,
    y1: 18.2656,
    x2: 10,
    y2: 2.73458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FF94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4974,
    stopColor: "#E9C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D48000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1556_9961",
    x1: 9.99998,
    y1: 3.43152,
    x2: 9.99998,
    y2: 17.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FF94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3194,
    stopColor: "#E9CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7016,
    stopColor: "#DDA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D48D00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameCoinIcon);
export default __webpack_public_path__ + "static/media/game-coin-icon.4275deb80f9c4cdb901ec24cd60f6c16.svg";
export { ForwardRef as ReactComponent };